import { BaseService } from '../../../infra/base.service'
import type { MedialistEntity } from './medialist.entity'
import type { MedialistsRepository } from './medialists.repository'

export class MedialistsService extends BaseService<MedialistEntity> {
    constructor(private rep: MedialistsRepository) {
        super(rep)
    }

    async getOnePublic(medialistId: string) {
        return await this.rep.getOnePublic(medialistId)
    }

    async getAllPublic(params: any = null) {
        return await this.rep.getAllPublic(params)
    }
}
